/**
 * Labstep
 */

import { Action } from 'labstep-web/components/PurchaseOrder/Action/Menu';

export const actions = [Action.print, Action.delete, Action.assign];
